import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[digitDate]',
})
export class DigitDateDirective {
  private navigationKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
  ];
  key;
  format = /^[0-9/]*$/;
  @HostListener('keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    this.key = e;
    console.log('data', this.key);
    if (
      this.allowNavigationKeys(e.key) || // Allow: navigation keys: backspace, delete, arrows etc.
      this.checkCtrl(e) || 
      this.checkCmd(e)
    ) {
      // let it happen, don't do anything
      return;
    }

    if (!this.format.test(this.key.key)) {
      e.preventDefault();
    }
  }

  // Allow: navigation keys: backspace, delete, arrows etc
  allowNavigationKeys(keyValue) {
    return this.navigationKeys.indexOf(keyValue) > -1;
  }
  checkCtrl(e) {
    switch (e.key) {
      case 'a': // Allow: Ctrl+A
      case 'c': // Allow: Ctrl+C
      case 'v': // Allow: Ctrl+V
      case 'x': // Allow: Ctrl+X
        return e.ctrlKey === true;
      default: 
        return false;
    }
  }
  checkCmd(e) {
    switch (e.key) {
      case 'a': // Allow: Cmd+A (Mac)
      case 'c': // Allow: Cmd+C (Mac)
      case 'v': // Allow: Cmd+V (Mac)
      case 'x': // Allow: Cmd+X (Mac)
        return e.metaKey === true;
      default: 
        return false;
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedInput: string = event.clipboardData.getData('text/plain');

    if (!this.format.test(pastedInput)) {
      event.preventDefault();
    } else {
      document.execCommand('insertText', false, pastedInput);
    }
  }
}
